import React, { useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Settings from '@mui/icons-material/Settings';
import { Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthService from 'src/_services/AuthService';
import generateCloudinaryLink from 'src/_utils/generateCloudinaryLink';
import { useSelector } from 'react-redux';

export default function ProfileAvatar() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const profile = useSelector((state) => state.entities.profile.profile);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleAvatarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logOut = () => {
        AuthService.logout();
        navigate('/auth/general', { replace: true });
    };

    return (
        <>
            <IconButton
                onClick={handleAvatarClick}
                size="small"
                sx={{ ml: 1 }}
                aria-controls={open ? 'merchant-avatar-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <Avatar
                    src={generateCloudinaryLink(profile?.merchant?.logo)}
                    sx={{
                        cursor: 'pointer',
                        width: 42,
                        height: 42,
                    }}
                >
                    <BusinessIcon />
                </Avatar>
            </IconButton>

            <Menu
                id="merchant-avatar-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disableScrollLock={true}
            >
                <MenuItem onClick={() => { navigate('/merchant/profile'); handleClose(); }}>
                    <ListItemIcon>
                        <AccountCircle />
                    </ListItemIcon>
                    <ListItemText>{t('Profile')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => { navigate('/merchant/account/info'); handleClose(); }}>
                    <ListItemIcon>
                        <Settings />
                    </ListItemIcon>
                    <ListItemText>{t('Commercial Info')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); logOut(); }}>
                    <ListItemIcon>
                        <Logout />
                    </ListItemIcon>
                    <ListItemText>{t('Log Out')}</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}
